import React, { useState, useEffect } from "react";
import {
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio
} from "@mui/material";
import moment from "moment";

import { withRouter } from "react-router";
import { compose } from "underscore";
import { connect } from "react-redux";
import { PROFILE } from "../../redux/constant";
import { updateProfile } from "../../redux/action";
import { gatherIdentities } from "../../../utils/functions/gatherIdentities";

import { StepLabel, CustomButton, DefaultLoader } from "../../../components";

import { allowedIdType } from "../../../utils/allowedIdType";
import styles from "../styles";

const UpdateInvestmentObj = props => {
  const {
    loading,
    profile,
    updateProfile,
    history,
    investmentObjective,
  } = props;

  const [investObj, setInvestObj] = useState("");

  const localIdentity = profile?.identities?.find(allowedIdType);

  useEffect(() => {
    if (profile) {
      setInvestObj(profile?.investmentObjCd ? profile?.investmentObjCd : "");
    }
  }, [profile]);

  const handleUpdate = () => {
    const payload = {
      masterId: profile?.masterId, //R
      email: profile?.email, //R
      mobileNo: profile?.mobileNo, //R
      fullName: profile?.fullName, //R
      townOfBirth: profile?.townOfBirth, //R
      dob: moment(profile?.dob).format("YYYY-MM-DD"), //R
      race: profile?.race, //R
      natureOfBusinessCd: profile?.natureOfBusinessCd, //R
      occupationTypeCd: profile?.occupationTypeCd, //R
      maritalStatusCd: profile?.maritalStatusCd, //R
      yearlyIncomeLevelCd: profile?.yearlyIncomeLevelCd, //R
      sourceOfFundCd: profile?.sourceOfFundCd,
      investmentObjCd: investObj,
      employerName: profile?.employerName,
      optIn: Boolean(profile?.optIn),
      isVc: Boolean(profile?.isVc),
      identities: gatherIdentities(profile, localIdentity),
      address: {
        line1: profile?.contacts.find(
          contact => contact.contactTypeCd === "PERMANENT"
        ).line1, //R
        postCode: profile?.contacts.find(contact => contact.postCode).postCode, //R the updated
        city: profile?.contacts.find(
          contact => contact.contactTypeCd === "PERMANENT"
        ).city, //R
        state: profile?.contacts.find(contact => contact.state).state, //R,
        country: localIdentity?.citizenship, //R
      },
    };

    if (payload.isVc) {
      payload.vcDescription = profile?.vcDescription;
    }

    // window.consoleLog(payload);
    updateProfile({ payloadData: payload, from: PROFILE });
  };

  return (
    <div style={{ backgroundColor: "#fff", ...styles.container }}>
      {loading && <DefaultLoader />}

      <StepLabel
        title="Update purpose of investment"
        onClick={() => history.back()}
        containerStyles={{ margin: "16px 16px 22px" }}
      />
      <form style={{ margin: "16px 16px 0 16px" }}>
        <FormControl fullWidth style={{ marginBottom: "14px" }}>
          <Typography
            color="textPrimary"
            sx={{    fontSize: "14px",
            fontWeight: "700",
            lineHeight: 1.57,
            marginBottom: "8px"}}
          >
            Purpose of investment
          </Typography>
          <RadioGroup
            name="investObj"
            value={investObj}
            onChange={e => setInvestObj(e.target.value)}
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center"
            }}
          >
            {investmentObjective
              .sort((a, b) => a.code - b.code)
              .map(({ code, name }) => (
                <FormControlLabel
                  value={code}
                  control={<Radio color="primary" />}
                  label={name}
                  key={code}
                />
              ))}
          </RadioGroup>
        </FormControl>
      </form>
      <div style={styles.btnContainer}>
        <CustomButton
          text="Save"
          variant="contained"
          color="#fff"
          backgroundColor="#1278CC"
          disabled={investObj ? false : true}
          onClick={handleUpdate}
        />
      </div>
    </div>
  );
};

const withConnect = connect(
  state => ({
    loading: state.goal.loading,
    isModalOpen: state.goal.isModalOpen,
    errorMessage: state.goal.errorMessage,
    profile: state.goal.profile,
    investmentObjective: state.onBoardingReducer.investmentObjective,
  }),
  { updateProfile }
);

export default compose(
  withRouter,
  withConnect
)(UpdateInvestmentObj);
